import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft } from 'lucide-react';

export const TopBar: React.FC = () => {
  return (
    <div className="w-full bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-start h-12">
          <Button
            variant="ghost"
            size="sm"
            className="text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
            onClick={() => window.open('https://indexsolidarity.cz/', '_blank')}
          >
            <ChevronLeft className="h-4 w-4 mr-1" />
            Zpět na Index solidarity
          </Button>
        </div>
      </div>
    </div>
  );
};